jQuery(document).ready(function($) {

	$.search = {
		init: function() {
			$.search.events();
		},

		events: function() {

			$(document).on('click', '.m-search-form__button', function(e) {
				var oSearch = $('.l-search');
				oSearch.toggleClass('active');

				oSearch.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function() {
					$('.m-search__form-input').focus();

					$(document).on('keydown', function (e) {
						if (e.keyCode === 27) { // ESC
							$('.m-search__close').trigger("click");
						}
					});
				});
			});

			$(document).on('click touchstart', '.m-search__close', function(e) {
				var oSearch = $('.l-search');
				oSearch.removeClass('active');
				
				$('.m-search-form__button').focus();
			});

			$('.m-search-content__form__submit').on('click', function() {
				$('form.m-search-content__form').submit();
			});

		},
	}

});